const CustomersBranding = ({ hospitalImage, hospitalLogo, hospitalName, shellWidth }) => (
    hospitalName || hospitalImage ? (
        <div className="d-flex flex-column align-items-center mb-2 sticky-top bg-white" style={{ minWidth: shellWidth, zIndex: 1 }}>
            {hospitalLogo && hospitalImage && (
                <img src={hospitalImage} alt="" style={{ maxHeight: '100px', maxWidth: '100px' }} />
            )}
            {hospitalName && (
                <span className="app-brand-text fw-bolder text-center" style={{ fontSize: '20px', color: '#041F60' }}>
                    {hospitalName}
                </span>
            )}
            <h5 className="text-secondary mt-3 text-center fw-bold" style={{ fontSize: '16px' }}>CONSULTATION LIST</h5>
        </div>
    ) : (
        <div className="d-flex flex-column align-items-center mb-2 mt-5" style={{ minWidth: shellWidth }}>
            <img src="/applogo.png" alt="OHOINDIA logo" style={{ maxHeight: '60px', maxWidth: '60px' }} />
            <span className="app-brand-text fw-bolder" style={{ fontSize: '25px', color: '#041F60' }}>OHOINDIA</span>
            <h5 className="text-secondary mt-3 text-center fw-bold" style={{ fontSize: '16px' }}>CONSULTATION LIST</h5>
        </div>
    )
);

export default CustomersBranding;
